import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { FormattedMessage } from 'react-intl';

import { CoordinateInput } from '#components/form/CoordinateInput.tsx';
import { useShortLocale } from '#configuration/lang/useLocale.ts';
import type { AddressTypes } from '#features/orderForm/ui/LocationForm.tsx';

type CoordinatesProps = {
    marker: boolean;
    onClick: () => void;
    addressType: AddressTypes;
    coordinatesPrefix?: string;
};
export const Coordinates = ({ marker, onClick, addressType, coordinatesPrefix }: CoordinatesProps) => {
    const locale = useShortLocale();
    const coordinateField = (field: 'latitude' | 'longitude') =>
        coordinatesPrefix ? `${coordinatesPrefix}.${field}` : field;

    return (
        <>
            <label
                htmlFor={'coordinates'}
                className='display-inline-flex flex-wrap justify-content-between width-100pct'
            >
                <span className='text-color-gray text-size-12 max-width-90pct truncate ml-1 inline-block w-200pct'>
                    <FormattedMessage
                        id={`intl-msg:ordercom-cloud-frontend.orders.create-dialog.coordinates-link.${addressType}`}
                        values={{
                            link: (chunks: React.ReactNode) => (
                                <a
                                    href={`https://rio.cloud/${locale}/documents/order-communication/how-to/user-manual/orders#c151499`}
                                    target='_blank'
                                    rel='noreferrer'
                                    {...getTrackingAttributes({
                                        trigger: 'click',
                                        category: 'link autoTracking',
                                        action: 'link click',
                                        label: `ordercom.orders.create-dialog.coordinates-link.${addressType}`,
                                    })}
                                >
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                </span>
                {marker && (
                    <span className='input-group-addon' onClick={onClick}>
                        <span className={'uikit-icon icon-remove-sign '} />
                    </span>
                )}
            </label>
            <span />
            {marker && (
                <div className={'form-group'}>
                    <div className={'display-flex gap-10'}>
                        <div className='width-50pct'>
                            <CoordinateInput name={coordinateField('latitude')} disabled />
                        </div>
                        <div className='width-50pct'>
                            <CoordinateInput name={coordinateField('longitude')} disabled />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
